import React from 'react';
import {useI18nContext} from "../../../contexts/I18nContext";
import RemittanceStatusHistoryStore from "./AttachmentsStore";
import RoundedButton from "../../../ui_components/RoundedButton/RoundedButton";
import {Observer} from "mobx-react-lite";
import {useStyles} from "./AttachmentsButton.style";
import Button from "../../../ui_components/Button/Button";
import ButtonType from "../../../ui_components/Button/ButtonType";
import {useCommonContext} from "../../../contexts/CommonContext";
import ButtonSize from "../../../ui_components/Button/ButtonSize";
import Box from "../../../ui_components/Box/Box";
import Width from "../../../ui_components/common/enums/Width";
import Alignment from "../../../ui_components/common/enums/Alignment";
import AttachmentsButtonProperties from './AttachmentsButtonProperties';
import SidePanel from "../../../ui_components/SidePanel/SidePanel";
import ImageIcon from '@mui/icons-material/Image';
import Link from '../../../ui_components/Link/Link';
import ShowAttachments from '../../Info/ShowAttachments/ShowAttachments';
import NewAttachmentButton from '../NewAttachmentButton/NewAttachmentButton';

const AttachmentsButton: React.FC<AttachmentsButtonProperties> = ({
                                                                          showIcon = true,
                                                                          showText = true,
                                                                          disabled,
                                                                          className = '',
                                                                          deliveryOrderId,
                                                                          deliveryOrderNumber,
                                                                          rounded = false,
                                                                          isLinkText,
                                                                          size = ButtonSize.DEFAULT,
                                                                          type = ButtonType.DEFAULT,
                                                                          onClose
                                                                      }) => {
    const classes = useStyles(showText);

    const i18n = useI18nContext();
    const commonContext = useCommonContext();
    const store = new RemittanceStatusHistoryStore(commonContext, deliveryOrderId);

    var commentAdded = false;

    const handleOnclick = async () => {
        await store.openModal();
    }

    const onCloseModal = () => {
        store.closeModal();
        if (commentAdded && onClose) {
            onClose();
        }
        commentAdded = false;
    }

    const text = 'ANEXOS';
    const Icon = ImageIcon;
    const Btn = () => {
        if (isLinkText) {
            return <Link text={'ANEXOS'} onClick={handleOnclick} startIcon={ImageIcon}></Link>
        }
        if (rounded) {
            return <RoundedButton
                onClick={handleOnclick}
                className={className}
                disabled={disabled}
                tooltip={!showText ? text : ""}
                text={showText ? text : ""}
                type={type}
                icon={showIcon ? <Icon/> : <></>}
            />
        }
        return <Button
            text={showText ? text : ""}
            className={className}
            tooltip={!showText ? text : ""}
            disabled={disabled}
            size={size}
            onClick={handleOnclick}
            type={type}
            startIcon={showIcon ? <Icon/> : <></>}
        />
    }
    return <Observer>
        {() => (
            <>
                <SidePanel title={text} onClose={onCloseModal} open={store.isModalOpen}
                       className={classes.modal_container}>
                    <div className={classes.history_container}>
                        <Box
                            className={classes.header_container}
                            width={Width.FULL_WIDTH}
                            justifyContent={Alignment.START}>
                            <div>{i18n.translate("REMITTANCE_ORDER_NUMBER")}: <strong className={classes.margin_left_4}>{deliveryOrderNumber}</strong></div>
                            <div>
                                <NewAttachmentButton
                                    productOrderId={deliveryOrderId}
                                    onUploadSuccess={() => {
                                        store.loadMoneyDeliveryOrderAttachments();
                                    }}
                                />
                            </div>
                        </Box>
                        <div className={classes.body}>
                            {<ShowAttachments attachments={store.attachments} />}
                        </div>
                    </div>
                </SidePanel>
                <Btn/>
            </>
        )}
    </Observer>
}

export default AttachmentsButton;
